import { createContext } from 'react'

import { BenchmarksContextValueType } from './BenchmarksContext.types'

export const BenchmarksContext = createContext<BenchmarksContextValueType | undefined>(undefined)
